import { Box } from '@chakra-ui/react';
import { DOC_TYPE_FIELDS } from './constants';

export const Divider = () => (
  <Box flex="1" borderTop="1px solid" borderColor="border-color" />
);

export const getAttachmentKey = (attachment) => {
  const prefixMap = {
    ats_attachment: `ats_${attachment.ats_attachment_id}`,
    offer_document_pdf: `pdf_${attachment.offer_id}`,
    offer_document_docx: `docx_${attachment.offer_id}`,
    additional_document: `add_${attachment.attachment_id}`,
  };
  return (
    prefixMap[attachment.type] ?? `${attachment.type}_${attachment.filename}`
  );
};

export const formatAttachmentType = (type) =>
  type
    .replace(/(_|\.)(pdf|docx?|jpe?g|png)$/i, '')
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (l) => l.toUpperCase());

export const mapDocForSubmit = (doc) => {
  const fields = DOC_TYPE_FIELDS[doc.type];
  if (fields) {
    return fields.reduce((acc, field) => ({ ...acc, [field]: doc[field] }), {
      type: doc.type,
    });
  }
  return {
    type: 'uploaded_file',
    file: doc.file,
    filename: doc.filename,
    content_type: doc.content_type,
  };
};
